import * as types from '../../../../../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  customerInfo: null,
  loader: false,

  edit_loader: false,
  editModalState: false,
  customer_edited_succesfully: false,
  customer_edited_failed: false,
};

export default function DcpRegistrationReducer(state = initialState, action) {
  switch (action.type) {
    case types.REGISTER_DCP_CUSTOMER_REQUEST:
      return { ...state, loader: true, errors: null, customerInfo: null };

    case types.REGISTER_DCP_CUSTOMER_SUCCESS:
      return { ...state, customerInfo: action.payload, loader: false };

    case types.REGISTER_DCP_CUSTOMER_FAIL:
      return { ...state, loader: false, errors: action.payload };

    case types.SET_DCP_REGISTRATION_ERROR:
      return { ...state, loader: false, errors: action.payload };

    case types.RESET_DCP_REGISTRATION:
      return initialState;

    case types.USER_LOGOUT:
      return initialState;


    case types.UPDATE_DCP_CUSTOMER_REQUEST:
      return { ...state, edit_loader: true, errors: null, customer_edited_succesfully: false, customer_edited_failed: false };


    case types.UPDATE_DCP_CUSTOMER_SUCCESS:
      return {
        ...state,
        edit_loader: false,
        editModalState: false,
        customer_edited_succesfully: true,
        customer_edited_failed: false
      };

    case types.UPDATE_DCP_CUSTOMER_FAIL:
      return {
        ...state,
        loader: false,
        edit_loader: false,
        errors: action.payload,
        customer_edited_succesfully: false,
        customer_edited_failed: true
      };

    case types.UPDATE_CUSTOMER_DCP_RESET:
      return {
        ...state,
        loader: false,
        edit_loader: false,
        editModalState: false,
        customer_edited_succesfully: false,
        customer_edited_failed: false
      };

    case types.EDIT_DCP_CUSTOMER_DISPLAY_ERROR:
      return { ...state, errors: action.payload };

    default:
      return state;
  }
}
